import React from 'react'
import '../styles/CompanyPage1.css'



const CompanyPage1Content = () => {

    return (
        <>
            <div className='companyPageContainer'>
                <section>
                    <h1>Legal Page</h1><p>This is the legal page template. It is a great starter for your company's Terms of Service, Terms &amp; Conditions,
                        Privacy Policy, etc.</p><h2>Terms of Service</h2><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore, obcaecati. Aspernatur facilis molestias
                            vitae. Aliquid debitis eum quis repudiandae pariatur possimus provident accusantium reiciendis nemo, culpa labore
                            laborum, dolorum ea.</p><p>Corrupti impedit perferendis, libero in, voluptates quod ratione repudiandae veniam sapiente necessitatibus, eius
                                illo. Impedit quibusdam esse saepe placeat incidunt voluptatibus soluta dolore blanditiis ad provident animi
                                illum, est adipisci?</p><p>Ratione optio necessitatibus numquam dignissimos sunt molestiae ipsum fugiat quae maxime veniam aspernatur eius
                                    quidem vel reprehenderit sequi, molestias perspiciatis, illo architecto perferendis nobis, in dolore! Nam
                                    asperiores eaque totam.</p><p>Repudiandae, labore alias. Voluptatem quia itaque sequi, aperiam, reprehenderit ipsum libero quae adipisci
                                        possimus eum esse corrupti sapiente harum dignissimos eligendi cum iure tempora magnam nemo, sunt provident vero.
                                        Voluptatibus.</p><h2>Privacy Policy</h2><p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Natus eveniet quibusdam ipsa, veniam adipisci rerum
                        temporibus inventore! Sit quas vero laboriosam tempora alias! Fugit, saepe earum quod modi harum qui.
                        Expedita, pariatur consequuntur! Modi, maiores. Quaerat voluptatibus nostrum non harum rerum dolorem totam qui
                        repellendus, itaque dignissimos eveniet consequuntur ducimus! Non commodi magnam nemo, pariatur facilis
                        repellendus sunt fuga ipsa.
                    </p><p>Consequuntur similique ab ea tenetur, quo aperiam molestias sed facilis minus eaque eveniet libero quis
                        accusantium deleniti tempore? Qui vel reiciendis voluptates corporis eum repellat maiores fugit, eveniet sapiente
                        ad.</p>
                </section>
            </div>
        </>

    )


}
export default CompanyPage1Content;